import { render, staticRenderFns } from "./InsightsSection.vue?vue&type=template&id=58f380a1"
import script from "./InsightsSection.vue?vue&type=script&lang=js"
export * from "./InsightsSection.vue?vue&type=script&lang=js"
import style0 from "./InsightsSection.vue?vue&type=style&index=0&id=58f380a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports